
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[summitKey]/register",
      function () {
        return require("private-next-pages/event/[summitKey]/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[summitKey]/register"])
      });
    }
  